import React from "react";
import { Link } from "react-router-dom";
import "./navlink.css";

const NavLink = ({ className = "", linkText, onClick, to }) => {
  const linkClassName = ["site_nav_link", className].filter(Boolean).join(" ");

  return (
    <Link className={linkClassName} onClick={onClick} to={to}>
      {linkText}
    </Link>
  );
};

export default NavLink;
